import { Route } from "vue-router";

const trackPageView = (to: Route) => {
    const name = to.name || to.path
    const { pathname, href } = window.location

    const segment = (<any>window).rudderanalytics
    if(!segment) return
    segment && segment.page(name, {
        url: href,
        path: pathname
    })
 
}

export default trackPageView
